import { render, staticRenderFns } from "./samecityMasterlist.vue?vue&type=template&id=4a16172e&scoped=true"
import script from "./samecityMasterlist.vue?vue&type=script&lang=js"
export * from "./samecityMasterlist.vue?vue&type=script&lang=js"
import style0 from "./samecityMasterlist.vue?vue&type=style&index=0&id=4a16172e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a16172e",
  null
  
)

export default component.exports